<template>
  <div>
    <b-form-row v-if="!disableName">
      <b-col cols="3">
        <label>First & Last Name</label>
      </b-col>
      <b-col>
        <b-form-input
          type="text"
          required
          :disabled="disableEditing"
          v-model="addressData.firstName"
        />
      </b-col>
      <b-col>
        <b-form-input
          type="text"
          required
          :disabled="disableEditing"
          v-model="addressData.lastName"
        />
      </b-col>
    </b-form-row>
    <b-form-row v-if="!disableName">
      <b-col>
        <label>Company</label>
      </b-col>
      <b-col cols="9">
        <b-form-input
          type="text"
          :disabled="disableEditing"
          v-model="addressData.company"
        />
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col>
        <label>Street 1</label>
      </b-col>
      <b-col cols="9">
        <b-form-input
          type="text"
          required
          :disabled="disableEditing"
          v-model="addressData.street1"
        />
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col cols="4" class="text-right">
        <b-checkbox
          v-model="addressData.residential"
        >
        Res?
        </b-checkbox>
      </b-col>
      <b-col>
        <label>Street 2</label>
      </b-col>
      <b-col cols="6">
        <b-form-input
          type="text"
          :disabled="disableEditing"
          v-model="addressData.street2"
        />
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col cols="3">
        <label>City</label>
      </b-col>
      <b-col>
        <b-form-input
          type="text"
          required
          :disabled="disableEditing"
          v-model="addressData.city"
        />
      </b-col>
      <b-col cols=*>
        <label>State</label>
      </b-col>
      <b-col cols="4">
        <b-form-select
          v-if="countries && addressData.country && Object.keys(countries[addressData.country].states).length != 0"
          required
          :disabled="disableEditing"
          :options="niceStates"
          v-model="addressData.region"
        />
        <b-form-select
          v-else-if="addressData.region"
          :disabled="disableEditing"
          :options="[{ text: addressData.readOnlyRegion, value: addressData.readOnlyRegion }]"
          v-model="addressData.region"
        />
        <b-form-select
          v-else
          :disabled="disableEditing"
          :options="[{ text:'No State', value: null }]"
          v-model="addressData.region"
        />
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col cols=3>
        <label>Country</label>
      </b-col>
      <b-col>
        <b-form-select
          required
          v-if="countries"
          :disabled="disableEditing"
          :options="niceCountries"
          v-model="addressData.country"
          @input="handleChangeCountry"
        />
      </b-col>
      <b-col cols="*">
        <label>ZIP</label>
      </b-col>
      <b-col cols=2>
        <b-form-input
          v-if="addressData.postal_code"
          type="text"
          required
          :disabled="disableEditing"
          v-model="addressData.postal_code"
        />
        <b-form-input
          v-else
          type="text"
          required
          :disabled="disableEditing"
          v-model="addressData.zip"
        />
      </b-col>
      <b-col cols="*">
        <label>Phone #</label>
      </b-col>
      <b-col>
        <b-form-input
          type="text"
          required
          :disabled="disableEditing"
          v-model="addressData.phone_number"
        />
      </b-col>
    </b-form-row>
    <b-form-row v-if='typeof(addressData.eori_number) !== "undefined"'>
      <b-col cols="3">
        <label>EORI Number (EU customers only)</label>
      </b-col>
      <b-col>
        <b-form-input
          type='text'
          required
          :disabled='disableEditing'
          v-model="addressData.eori_number"
        />
      </b-col>
    </b-form-row>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  props: {
    addressData: { type: Object, default: () => {} },
    disableEditing: { type: Boolean, default: false },
    disableName: { type: Boolean, default: false },
  },
  computed: {
    ...mapGetters({
      countries: 'countries',
    }),
    streetAddress() {
      return `${this.address.street1}, ${this.address.city},
        ${this.address.region} ${this.address.zip || this.address.postal_code} ${this.address.country}`
    },
    niceCountries() {
      if(this.countries) {
        return Object.keys(this.countries).map((abbr) => {
          return {text: `${abbr} | ${this.countries[abbr].name}`, value: abbr}
        });
      } else {
        return {}
      }
    },
    niceStates() {
      if(this.countries) {
        const currentCountry = this.countries[this.addressData.country];
        let stateList = [];
        (Object.keys(currentCountry.states).map((abbr) => {
          stateList.push({
            text: `${abbr} | ${currentCountry.states[abbr] || '???'}`,
            value: abbr
          })
        }))
        if (this.addressData.country == this.addressData.readOnlyCountry && !currentCountry.states[this.addressData.readOnlyRegion]) {
          stateList.push({text: `${this.addressData.readOnlyRegion} | What FB Found`, value: this.addressData.readOnlyRegion})
        }
        return stateList;
      } else {
        return {};
      }
    }
  },
  methods: {
    ...mapActions({
      getCountries: 'getCountries',
    }),
    handleChangeCountry(event) {
      this.addressData.region = null;
      this.$forceUpdate();
    },
  },
  mounted() {
    this.getCountries();
  },
};
</script>

<style scoped>
  .form-row {
    margin-bottom: 0.25em;
  }

  label {
    float: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/sales-order/edit-order/Address.vue